import { useQuery } from 'react-query'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../../hooks/services'

const hookName = 'useCalendarIntegrations'
const log = logFactory(hookName)

const useCalendarIntegrations = (resourceId: string | undefined) => {
  const { getCalendarIntegrations, isReady } = useAppointmentsService()

  const fetchCalendarIntegrations = async () => {
    if (!resourceId) {
      return
    }
    log(`📆 Fetching calendar integrations...`, { resourceId })

    return getCalendarIntegrations(resourceId)
  }

  const isQueryEnabled = Boolean(isReady && resourceId)
  const results = useQuery([hookName, resourceId], fetchCalendarIntegrations, { enabled: isQueryEnabled })
  const { data } = results

  return {
    ...results,
    calendarIntegrations: data,
  }
}

export { useCalendarIntegrations }
